import { Team } from "@jane/lib/src/api/repositories/teams-repository"
import {useCallback, useMemo} from "react"


function sortTeamArrayItems(a: Team[], b: Team[]): number {
  const a1: Team|undefined = a[0]
  const b1: Team|undefined = b[0]
  if (a1 === undefined && b1 === undefined) {
    return 0
  }
  if (a1 === undefined && b1 !== undefined) {
    return -1
  }
  if (a1 !== undefined && b1 === undefined) {
    return 1
  }
  if (a1.id === b1.id) {
    return sortTeamArrayItems(a.slice(1), b.slice(1))
  }
  return a1.name.localeCompare(b1.name)
}

export function useTeamMap(teams: Team[], primaryTeam: Team|null, secondaryTeams: Team[]): Team[][] {
    const getParents = useCallback((team: Team): Team[] => {
        if (team.parentObjectId !== null) {
            const parent = teams.find(x => x.id === team.parentObjectId)
            if (parent !== undefined) {
                return [...getParents(parent), team]
            }
        }
        return [team]
    }, [teams])

    return useMemo(
        () => teams
            .map(team => getParents(team))
            .filter(teams => {
                if (teams.some(team => team.id === primaryTeam?.id)) {
                    return true
                }
                return secondaryTeams.some(st => st.id === teams.slice(-1)[0].id)
            })
            .sort(sortTeamArrayItems),
        [teams, getParents, primaryTeam?.id, secondaryTeams]
    )
}
export function getRelatedTeamIds(team: Team|undefined, teamMap: Team[][]): number[] {
    const teamHeirarchies = teamMap
        .filter(teams => team === undefined || teams.some(x => x.id === team.id))
    let results = new Set<number>()
    for (const teamHeirarchy of teamHeirarchies) {
        let hasFoundTeam = false
        for (const teamResult of teamHeirarchy) {
            if (teamResult.id === team?.id) {
                hasFoundTeam = true
            }
            if (hasFoundTeam || team === undefined) {
                results.add(teamResult.id)
            }
        }
    }

    return Array.from(results)
}
